import { AnyAction, combineReducers } from '@reduxjs/toolkit';
import userReducer from './user';
import appReducer, { resetAppData } from './app';
import roomReducer from './room';
import loginReducer from './login';
import { connectRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import meetingReducer from './meeting';
import contactReducer from './contact';
import approvalReducer from './approval';
import { clearLocalStorage } from 'data/storage';

/**
 * MODEL层定义：
 * 通用的业务模型和视图相关的模型应该是有所区分的
 */
export const _history = createBrowserHistory();
export const rootReducer = combineReducers({
  router: connectRouter(_history),
  app: appReducer,
  user: userReducer,
  login: loginReducer,
  room: roomReducer,
  meeting: meetingReducer,
  contact: contactReducer,
  approval: approvalReducer
});
export type _RootState = ReturnType<typeof rootReducer>;
// state 置为 any, 因为类型校验的问题
const createRootReducer = (state: any, action: AnyAction) => {
  if (action.type === resetAppData.type) {
    clearLocalStorage();
    state = { router: state.router };
  }

  return rootReducer(state, action);
};

export default createRootReducer;
